import { render, staticRenderFns } from "./sharemanagetable.vue?vue&type=template&id=84ec29ea&scoped=true&"
import script from "./sharemanagetable.vue?vue&type=script&lang=js&"
export * from "./sharemanagetable.vue?vue&type=script&lang=js&"
import style0 from "./sharemanagetable.vue?vue&type=style&index=0&id=84ec29ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ec29ea",
  null
  
)

export default component.exports